<template>
	<div
		v-if="authStore.session || isPublicRoute"
		class="drawer h-screen"
	>
		<input
			id="my-drawer-3"
			type="checkbox"
			class="drawer-toggle"
		/>
		<div class="drawer-content flex flex-col h-screen">
			<!-- Navbar -->
			<div
				v-if="authStore.session"
				class="w-full navbar bg-base-100 flex-none"
			>
				<div
					class="flex-none"
					v-if="authStore.session"
				>
					<label
						for="my-drawer-3"
						aria-label="open sidebar"
						class="btn btn-square btn-ghost"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							class="inline-block w-6 h-6 stroke-current"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M4 6h16M4 12h16M4 18h16"
							></path>
						</svg>
					</label>
				</div>
				<div class="flex-1 px-2 mx-2">
					<router-link to="/"> chidOS </router-link>
				</div>
				<div class="flex-none hidden lg:block">
					<ul class="menu menu-horizontal"></ul>
				</div>
			</div>
			<router-view class="bg-base-300 flex-grow"></router-view>
		</div>
		<div
			class="drawer-side"
			v-if="authStore.session"
		>
			<label
				for="my-drawer-3"
				aria-label="close sidebar"
				class="drawer-overlay"
			></label>
			<div class="w-80 h-full">
				<ul class="overflow-y-scroll menu p-4 w-80 min-h-full bg-base-200">
					<li @click="toggle">
						<router-link to="/"> Home </router-link>
					</li>
					<li
						v-for="section in sections"
						v-bind:key="section.title"
						class="w-full"
					>
						<details>
							<summary>{{ section.title }}</summary>
							<ul>
								<li
									v-for="link in section.links"
									v-bind:key="link.name"
									@click="toggle"
								>
									<router-link :to="{ name: link.name }">
										{{ link.meta.title }}
									</router-link>
								</li>
							</ul>
						</details>
					</li>
					<li
						v-for="link in links"
						v-bind:key="link.name"
						@click="toggle"
					>
						<router-link :to="{ path: link.path, force: true }">
							{{ link.meta.title }}
						</router-link>
					</li>
					<li class="mt-auto">
						<div>
							{{ versionStore.currentVersion }}
						</div>
						<button
							@click="signOut"
							class="w-full text-left"
						>
							Sign Out
						</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Show loading state while checking auth -->
	<div
		v-else-if="!authStore.isInitialized"
		class="flex items-center justify-center h-screen"
	>
		<div class="loading loading-spinner loading-lg"></div>
	</div>
	<!-- Show auth component for unauthenticated users on private routes -->
	<Auth v-else></Auth>
	<VersionUpdateModal :show="versionStore.showUpdateModal" />
</template>

<script>
import Auth from './views/Auth.vue'
import { navigation } from './constants/navigation'

import { onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTemplateStore } from './stores/templateStore'
import { useAuthStore } from './stores/authStore'
import { useVersionStore } from './stores/versionStore'
import VersionUpdateModal from './views/components/VersionUpdateModal.vue'

export default {
	name: 'AdminHome',
	components: {
		Auth,
		VersionUpdateModal
	},
	setup() {
		const route = useRoute()
		const router = useRouter()
		const authStore = useAuthStore()
		const versionStore = useVersionStore()

		// Dynamic sections based on user type
		const sections = computed(() => {
			const userType = authStore.userProfile?.user_type
			return userType ? navigation[userType]?.navigation || [] : []
		})

		const links = computed(() => {
			const userType = authStore.userProfile?.user_type
			return userType ? navigation[userType]?.links || [] : []
		})

		// Check if current route is public
		const isPublicRoute = computed(() => {
			return authStore.isRoutePublic(route.name)
		})

		async function signOut() {
			console.log('Signing out')
			await authStore.logout()
			router.push('/')
		}

		function toggle() {
			var box = document.getElementById('my-drawer-3')
			if (box) {
				box.checked = !box.checked
			}
		}

		// Watch route changes for version check
		watch(
			() => route.path,
			async (newPath, oldPath) => {
				if (newPath !== oldPath) {
					console.log(`[Version Check] Checking version on route change: ${oldPath} -> ${newPath}`)
					await versionStore.checkVersion()
				} else {
					console.debug(`[Version Check] Skipping check - same path: ${newPath}`)
				}
			}
		)

		onMounted(async () => {
			// Check auth separately
			await authStore.checkExistingSession()

			const templateStore = useTemplateStore()
			templateStore.fetchTemplates()

			// Initialize version checking
			await versionStore.checkVersion()

			// Set up periodic version checking
			setInterval(async () => {
				await versionStore.checkVersion()
			}, 5 * 60 * 1000) // Check every 5 minutes
		})

		return {
			sections,
			links,
			toggle,
			authStore,
			signOut,
			isPublicRoute,
			versionStore
		}
	}
}
</script>
